// src/pages/Home.js
import React, { useEffect, useState } from "react";
import BASE_URL from "../config";
import "../styles/Home.css"; // Import the CSS file
// import "../styles/Contact-us.css"; // Import the CSS file
import "@fortawesome/fontawesome-free/css/all.min.css"; // Import Font Awesome CSS
import parse, { domToReact } from "html-react-parser"; // Import domToReact for custom parsing
import NewsletterForm from "../components/NewsletterForm"; // Import the NewsletterForm component
import Loader from "../components/Loader"; // Import Loader component
import SEO from "../components/SEO.js";

// No changes needed to make this page accessible to unauthenticated users.
// Ensure no authentication checks are added in the future.

const Home = () => {
  const [pageContent, setPageContent] = useState(null);

  useEffect(() => {
    // Fetch content of the page with slug 'home'
    const fetchPageContent = async () => {
      try {
        const response = await fetch(`${BASE_URL}api/pages/find-by-slug/home`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        // console.log("Fetched Page Content:", data.content);
        setPageContent(data.content);
      } catch (error) {
        console.error("Error fetching page content:", error);
      }
    };

    fetchPageContent();
  }, []);

  const GetStartedButton = ({ className, href, dataIcon }) => {
    return (

      <a
        className={className}
        href={href}
        data-icon={dataIcon}
        onMouseEnter={(e) => {
          e.target.innerHTML = 'Get Started <span class="arrow">→</span>';
          const arrow = e.target.querySelector(".arrow");
          setTimeout(() => {
            arrow.style.transform = "translateX(5px)";
          }, 0);
        }}
        onMouseLeave={(e) => {
          e.target.innerHTML = "Get Started";
        }}
      >
        Get Started
      </a>
    );
  };

  const parseContent = (content) => {
    return parse(content, {
      replace: (domNode) => {
        if (domNode.type === "text" && domNode.data.includes("[Get Started Today!]")) {
          return (
            <PromoButton
              className="promo-button et_pb_button"
              href="contact-us"
              dataIcon="$"
            />
          );
        }
        if (domNode.type === "text" && domNode.data.includes("[Get Started]")) {
          return (
            <GetStartedButton
              className="et_pb_button et_pb_custom_button_icon et_pb_promo_button"
              href="contact-us"
              dataIcon="$"
            />
          );
        }
        if (domNode.type === "text" && domNode.data.includes("[Home newsletter-form]")) {
          return (
            <NewsletterForm />
          );
        }
        if (domNode.name === "script" && domNode.children.length > 0) {
          const scriptContent = domToReact(domNode.children);
          try {
            // Evaluate the script content safely
            // eslint-disable-next-line no-eval
            eval(scriptContent);
          } catch (error) {
            console.error("Error evaluating script:", error);
          }
          return null; // Do not render the script tag
        }
      },
    });
  };

  const PromoButton = ({ className, href, dataIcon }) => {
    const [buttonContent, setButtonContent] = useState("Get Started Today!");

    const handleMouseEnter = () => {
      setButtonContent(
        <>
          Get Started Today!{" "}
          <span
            style={{
              // fontSize: "1.2em",
              display: "inline-block",
              transform: "translateX(0)",
              transition: "transform 300ms ease",
            }}
          >
            →
          </span>
        </>
      );
    };

    const handleMouseLeave = () => {
      setButtonContent("Get Started Today!");
    };

    return (
      <a
        className={className}
        href={href}
        data-icon={dataIcon}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {buttonContent}
      </a>
    );
  };

  return (
<>
    <SEO slug="home" />
    <div style={{ fontFamily: "'Lato', Helvetica, Arial, Lucida, sans-serif" }}>
      {pageContent ? (
        <div>
          {parseContent(pageContent)}

          {/* <div className="entry-content" >
            <div id="et-boc" >
              <div>
                <div className="top-container" >
                  <div className="custom-flex" >
                    <div className="video-container">
                      <video
                        loop
                        autoPlay
                        playsInline
                        muted
                        preload="none"
                        src="https://res.cloudinary.com/softisans-com/video/upload/v1584473087/Softisans/Videos/code_f6mmrs.mp4"
                        className="video-style"
                      />
                    </div>
                    <div className="content-container">
                      <div className="content-section fade-in-up">
                        <div>
                          <div className="fade-in-up">
                            <div>
                              <h1 className="main-heading">Softisans</h1>
                              <h6 className="sub-heading">Crafting Quality Software</h6>
                            </div>
                          </div>
                          <div className="fade-in-opacity">
                            <div>
                              <h4 className="description">
                                We use creativity, passion, and our experience, to build your business.
                              </h4>
                            </div>
                          </div>
                          <div>
                            <div>
                              <a
                                href="skype:rizwan-ali?call"
                                className="cta-button"
                              >
                                LET’S TALK
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="green-section">
                        <div>
                          <div>
                            <div className="white-text fade-in-up">
                              <p>
                                <span>
                                  At Softisans, we deliver innovative, creative and quality products and services to grow your business,
                                  beyond your expectations. Among the different services we provide, graphic designing, web development,
                                  custom applications, CRMs, ERPs, e-commerce solutions, business to business applications and business to
                                  client applications, managed hosting and internet portal management, at reasonable charges and in-time
                                  delivery is our core strength. Happy customers around the world bear testimony to prove the quality of our
                                  work.
                                </span>
                              </p>
                              <p>
                                <span>
                                  Softisans’s business strategy is to assure the best quality product/services, client satisfaction,
                                  on-time delivery and the best quality-price ratio found in the industry. Our emphasis is on offering a
                                  high degree of product, user friendliness through creativity, passion, and our experience.
                                </span>
                              </p>
                            </div>
                            <div>
                              [Get Started Today!]

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="et_pb_bottom_inside_divider-home"
                    ></div>
                  </div>
                </div>

                <div className="happy-clients-section">
                  <div className="container container-clients-section">
                    <div className="text-section fade-in-up">
                      <div>
                        <h6 className="crafting-success">Crafting Your Business Success</h6>
                        <h2 className="strategy-heading">From Strategy to Deployment and Beyond…</h2>
                        <p className="strategy-description">
                          When you have an idea, the next step is to find the best technology partner to convert your idea to reality.
                          We are equipped with advanced and up-to-date skill sets to cater to specific and custom needs of yours. We are
                          a full-scale software development team that knows the value of lasting relationships as Quality is remembered
                          long after price is forgotten.
                        </p>
                      </div>
                      <div className="cta-container">
                        [Get Started]
                      </div>
                    </div>
                    <div class="features-list fade-in-opacity">
                      <p class="feature-item"><span class="feature-icon">✓</span>Connecting Business and Deep Technology</p>
                      <p class="feature-item"><span class="feature-icon">✓</span>700+ Happy Clients Across 40+ Countries</p>
                      <p class="feature-item"><span class="feature-icon">✓</span>Advanced and Up-to-date Skill Sets To Your Needs</p>
                      <p class="feature-item"><span class="feature-icon">✓</span>4.9/5 Customer Satisfaction and Rating</p>
                      <p class="feature-item"><span class="feature-icon">✓</span>Full-Cycle Software Development Approach</p>
                    </div>
                  </div>
                </div>
                <div className="about-section">
                  <div className="container about-container">
                    <div className="about-content">
                      <div className="about-details fade-in-up">
                        <div>
                          <h1 className="about-heading">About Us</h1>
                          <h1 className="vision-heading">Vision</h1>
                          <p className="about-paragraph">
                            Our vision is to grow as a major IT service provider, quality Web and Mobile applications
                            and Software Development solutions in the competitive global marketplace. Our professional,
                            flexible and dedicated approach guides our customers to success. Fortunately, we have a
                            talented crew of dedicated professionals who possess outstanding talent with their more
                            than two decades combined experience.
                          </p>
                          <h1 className="mission-heading">Mission</h1>
                          <p className="about-paragraph">
                            We ensure to build a culture based on best performance, service excellence through teamwork,
                            respect and recognition for all stakeholders, diverse and challenging work, and flexible and
                            rewarding career opportunities for our staff.
                          </p>
                          <p className="about-paragraph">
                            We strive for excellence through focusing on:
                          </p>
                          <ul className="about-list">
                            <li>People – recruiting, developing and retaining top individuals.</li>
                            <li>Process – ensuring quality services, with innovative, cost-effective and latest technology usage.</li>
                            <li>Clients – significantly and continually enhancing client satisfaction by meeting their goals.</li>
                          </ul>
                        </div>
                      </div>
                      <div className="newsletter-section">
                        <h1 className="newsletter-heading">Join Our Newsletter</h1>
                        [Home newsletter-form]
                        <div className="social-links fade-in-down">
                          <a href="https://www.facebook.com/softisans/" target="_blank" rel="noopener noreferrer" className="social-icon facebook">
                            <i className="fab fa-facebook-f"></i>
                          </a>
                          <a href="https://twitter.com/softisans_com" target="_blank" rel="noopener noreferrer" className="social-icon twitter">
                            <i className="fab fa-twitter"></i>
                          </a>
                          <a href="https://www.linkedin.com/company/softisans/" target="_blank" rel="noopener noreferrer" className="social-icon linkedin">
                            <i className="fab fa-linkedin-in"></i>
                          </a>
                          <a href="https://www.instagram.com/_softisans_/" target="_blank" rel="noopener noreferrer" className="social-icon instagram">
                            <i className="fab fa-instagram"></i>
                          </a>
                          <a href="https://www.pinterest.com/softisans/" target="_blank" rel="noopener noreferrer" className="social-icon pinterest">
                            <i className="fab fa-pinterest-p"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="et_pb_bottom_inside_divider2"
                  ></div>
                </div>
              </div>
            </div>
            <div>
              <div className="approach-section">
                <div className="approach-header fade-in-up">
                  <p className="approach-title">Approach</p>
                  <h1 className="approach-heading">Why Choose Us</h1>
                  <h2 className="approach-subheading">
                    “Quality is never an accident, it is always a result of intelligent effort.”
                    <br />
                    John Ruskin
                  </h2>
                </div>
                <div className="approach-cards fade-in-up">
                  <div className="approach-card">
                    <div className="approach-icon">
                      <i className="fas fa-chart-bar"></i>
                    </div>
                    <h3 className="approach-card-title">DRIVING INNOVATIVE WITH DEDICATION</h3>
                    <p className="approach-card-description">
                      Using cutting-edge technologies and with the help of highly responsible, dedicated and skilled team, we build
                      the awesome web, desktop and mobile top-notch applications.
                    </p>
                  </div>
                  <div className="approach-card">
                    <div className="approach-icon">
                      <i className="fab fa-google-drive"></i>
                    </div>
                    <h3 className="approach-card-title">QUICK AND RESPONSIVE</h3>
                    <p className="approach-card-description">
                      Everyone from startups to enterprise customers gets our full attention at Softisans. Our response time is quick
                      and meets almost any need, from product customization to fulfilling special requests.
                    </p>
                  </div>
                  <div className="approach-card">
                    <div className="approach-icon">
                      <i className="fas fa-check-circle"></i>
                    </div>
                    <h3 className="approach-card-title">RELIABILITY IS OUR TOP PRIORITY</h3>
                    <p className="approach-card-description">
                      Our highly skilled software engineers and consultants provide reliable software products and services at
                      competitive prices with accuracy in time and requirements.
                    </p>
                  </div>
                  <div className="approach-card">
                    <div className="approach-icon">
                      <i className="fas fa-lightbulb"></i>
                    </div>
                    <h3 className="approach-card-title">THINKING DEEPLY BEFORE WE ACT</h3>
                    <p className="approach-card-description">
                      Every client project needs are deeply researched to ensure that the delivered application provides high
                      value and meets business goals.
                    </p>
                  </div>
                </div>
              </div>
              <div class="et_pb_bottom_inside_divider3"></div>
            </div>
          </div> */}
        </div> // Use custom parseContent function
      ) : (
        <Loader message="Loading Home Page..." />
      )}

    </div>  </>

  );
};

export default Home;
